import { classes, stylesheet } from 'typestyle'

/* Core ========================================================================================= */
import { addSnippet } from '../../../core/snippet-manager'
import { flat } from '../../../share/obj-equal'
import { formatDate } from '../../../share/format'

/* Hooks ======================================================================================== */
import useBoolean from '../../../hooks/use-boolean'

/* Components =================================================================================== */
import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Text } from '../../../components/text/text.component'
import { Snippet } from '../../../modules/layouts/snippet'
import { Line } from '../../../components/line'

/* Styles ======================================================================================= */
import { f16i } from '../../../styles/styleset/font-size/f16i'
import { mt16 } from '../../../styles/styleset/margin/mt16'
import { paddingLeftInner } from '../../../styles/default/padding'
import { mb4 } from '../../../styles/styleset/margin/mb4'
import { mt4 } from '../../../styles/styleset/margin/mt4'
import { pb12 } from '../../../styles/styleset/padding/pb12'
import { pt12 } from '../../../styles/styleset/padding/pt12'
import { pb4 } from '../../../styles/styleset/padding/pb4'
import { pt4 } from '../../../styles/styleset/padding/pt4'

export default addSnippet('Description', (props: any) => {
  const { fields, description, row } = props
  const [toggle, $toggle] = useBoolean(true)

  if (!row || Object.keys(row).length === 0) {
    return null
  }

  return (
    <Snippet>
      {/* <SnippetHead title="Info" /> */}
      {description ? (
        <Box rounded row relative style={{ overflow: 'hidden' }}>
          <Box
            style={{
              left: 0,
              top: 0,
              width: 4,
              background: '#266ffb',
              height: '100%',
              position: 'absolute',
            }}
          />
          <Box className={classes(paddingLeftInner, pt12, pb12)} baseline="none">
            <Text baseline="surface" size="sm" shrink>
              {description}
            </Text>

            {fields?.length > 0 && (
              <Button
                className={mt16}
                icon={
                  !toggle ? (
                    <span className={classes(process.env.REACT_APP_GOOGLE_MATERIAL_ICONS, f16i)}>
                      keyboard_arrow_up
                    </span>
                  ) : (
                    <span className={classes(process.env.REACT_APP_GOOGLE_MATERIAL_ICONS, f16i)}>
                      keyboard_arrow_down
                    </span>
                  )
                }
                onClick={$toggle.toggle}
                label="Show metadata"
                size="xs"
                baseline="background"
                ariaLabel="Toggle Dropdown"
                square
              />
            )}
          </Box>
          {!toggle ? (
            <>
              <Line />
              <Box className={classes(paddingLeftInner, pt12, pb12)} baseline="none">
                {fields && fields.length ? (
                  fields.map(field => {
                    let value = ''
                    if (field.shape) {
                      field.shape.map(func => {
                        const [def, args]: any = func
                        if (def == 'formatDate') {
                          value = formatDate.apply(null, [row[field.value], args[0]])
                        }
                      })
                    }

                    if (field.withLookup) {
                      const fullKey = `${field.value}.${field.key}`
                      const flatObj = flat(row)
                      value = flatObj[fullKey]
                    }

                    if (!value) {
                      value = row[field.value]
                    }

                    if (!value) {
                      return
                    }

                    return (
                      <Box
                        key={field.value}
                        fullWidth
                        flex
                        className={classes(mt4, mb4)}
                        alignCenterY
                      >
                        <Box minWidth={80} flex alignCenterY>
                          <Text baseline="surface" size="xs">
                            {field.label}
                          </Text>
                        </Box>
                        <Box flex alignCenterY>
                          <Text baseline="surface" size="xs" semiBold>
                            {value}
                          </Text>
                        </Box>
                      </Box>
                    )
                  })
                ) : (
                  <></>
                )}
              </Box>
            </>
          ) : (
            <></>
          )}
        </Box>
      ) : (
        <Box rounded row relative style={{ overflow: 'hidden' }}>
          <Box
            style={{
              left: 0,
              top: 0,
              width: 4,
              background: '#266ffb',
              height: '100%',
              position: 'absolute',
            }}
          />
          <Box className={classes(paddingLeftInner, pt4, pb4)} baseline="none">
            {fields && fields.length ? (
              fields.map(field => {
                let value = ''
                if (field.shape) {
                  field.shape.map(func => {
                    const [def, args]: any = func
                    if (def == 'formatDate') {
                      value = formatDate.apply(null, [row[field.value], args[0]])
                    }
                  })
                }

                if (field.withLookup) {
                  const fullKey = `${field.value}.${field.key}`
                  const flatObj = flat(row)
                  value = flatObj[fullKey]
                }

                if (!value) {
                  value = row[field.value]
                }

                if (!value) {
                  return
                }

                return (
                  <Box key={field.value} fullWidth flex className={classes(mt4, mb4)} alignCenterY>
                    <Box minWidth={80} flex alignCenterY>
                      <Text baseline="surface" size="xs">
                        {field.label}
                      </Text>
                    </Box>
                    <Box flex alignCenterY>
                      <Text baseline="surface" size="xs" semiBold>
                        {value}
                      </Text>
                    </Box>
                  </Box>
                )
              })
            ) : (
              <></>
            )}
          </Box>
        </Box>
      )}
    </Snippet>
  )
})

const STYLES = stylesheet({
  item: {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 'unset',
    width: 3,
    height: '100%',
    background: '#266ffb',
    transition: '#266ffb',
    transitionProperty: 'all',
    zIndex: 0,
  },
  itemText: {
    color: '#989898',
  },
})
